import request from '@/utils/request'

export function getButtons(id) {
  return request({
    url: `/admin/v1/menus/${id}/buttons`,
    method: 'get'
  })
}
